<template>
    <div id="modelViews" class="modelViews">
        <el-dialog
            :title="title"
            :visible.sync="modelViewsStatus"
            :close-on-click-modal="false"
            :before-close="closeModelViewsDialog"
            width="30%"
        >
            <!--<el-tabs v-model="typeName" type="border-card" @tab-click="handleClick">-->
            <el-tabs v-model="activeName" type="border-card">
                <el-tab-pane label="流式" name="lod" :disabled="isDisabled.lod">
                    <div class="views-tabs-container">
                        <multiViewsTabs
                            ref="lodMultiViewsTabs"
                            convertType="lod"
                            :jobType="allJobType.lod"
                            :fileName="fileName"
                            :fileFormat="fileFormat"
                            :currentUrn="currentUrn"
                            :tokenData="tokenData"
                            :version="version"
                            :convertData="convertData.lod"
                            @shareModelView="shareModelView"
                            :key="multiViewsTabsKey"
                        ></multiViewsTabs>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="全量" name="obv" :disabled="isDisabled.obv">
                    <div class="views-tabs-container">
                        <multiViewsTabs
                            ref="obvMultiViewsTabs"
                            convertType="obv"
                            :jobType="allJobType.obv"
                            :fileName="fileName"
                            :fileFormat="fileFormat"
                            :currentUrn="currentUrn"
                            :tokenData="tokenData"
                            :version="version"
                            :convertData="convertData.obv"
                            @shareModelView="shareModelView"
                            :key="multiViewsTabsKey"
                        ></multiViewsTabs>
                    </div>
                </el-tab-pane>
            </el-tabs>

            <span slot="footer" class="dialog-footer">
                <button class="cancel-btn" @click.prevent="closeModelViewsDialog">取消</button>
            </span>
        </el-dialog>
        <modelViewsShare ref="modelViewsShare"></modelViewsShare>

        <!-- 分享 -->
        <!-- <modelViewsShare ref="modelViewsShare" :jobType="jobType" ></modelViewsShare> -->

        <!-- <share :prop @emit> -->
    </div>
</template>
<script>
import { getObjectViewToken } from 'src/utils/modelUtils';
import { analysisFileType } from 'src/utils/commonUtils.js';
import multiViewsTabs from 'src/pages/devCenter/consoleLab/components/multiViewsTabs';
import modelViewsShare from 'src/pages/devCenter/consoleLab/components/modelViews-share';

export default {
    name: 'modelViews',
    components: {
        multiViewsTabs,
        modelViewsShare,
    },
    data() {
        return {
            modelViewsStatus: false, //是否打开dialog
            activeName: '', //相当于activeView，用来控制面板停留位置
            modelViewsKey: 0,
            currentUrn: '',
            title: '模型视图',
            fileName: '',
            fileFormat: '',
            tokenData: '', // 浏览用的token
            version: '', //obv版本
            isDisabled: {
                obv: false,
                lod: false,
            },
            convertStartTime: {
                obv: '',
                lod: '',
            },
            convertMeta: {
                obv: '',
                lod: '',
            },
            multiViewsTabsKey: 0,
        };
    },
    props: {
        allJobType: Object,
        objectStatus: Object,
        convertData: Object,
    },
    methods: {
        setActiveName() {
            this.isDisabled.lod ? this.activeName = 'obv' : this.activeName ='lod';
        },
        // v5 or v4传递不同的参数
        OpenV5(urn, fileName) {
            const _self = this;
            _self.title = `模型视图-${fileName}`;
            _self.fileName = fileName;
            _self.fileFormat = analysisFileType(fileName);
            _self.currentUrn = urn;
            _self.multiViewsTabsKey++;
            _self.modelViewsStatus = true;
            getObjectViewToken().then((res) => {
                _self.tokenData = res.data.newToken;
                _self.$refs.obvMultiViewsTabs.isLoading = true;
                _self.$refs.lodMultiViewsTabs.isLoading = true;
                !_self.isDisabled.obv ? _self.$refs.obvMultiViewsTabs.initModelViews(res.data.newToken, `${urn}`) : '';
                !_self.isDisabled.lod ? _self.$refs.lodMultiViewsTabs.initModelViews(res.data.newToken, `${urn}`) : '';
                 _self.setActiveName();
            });
        },
        OpenV4(urn, fileName, version) {
            this.isLoading = true;
            const _self = this;
            _self.title = `模型视图-${fileName}`;
            _self.fileName = fileName;
            _self.currentUrn = urn;
            _self.version = version;
            _self.modelViewsStatus = true;
            getObjectViewToken().then((res) => {
                _self.tokenData = res.data.newToken;
                _self.$refs.obvMultiViewsTabs.initModelViews(res.data.newToken, `${urn}`);
                _self.$refs.lodMultiViewsTabs.initModelViews(res.data.newToken, `${urn}`);
            });
        },
        closeModelViewsDialog() {
            this.$refs.obvMultiViewsTabs.modelViewsData = [];
            this.$refs.lodMultiViewsTabs.modelViewsData = [];
            this.modelViewsStatus = false;
        },
        shareModelView(viewModel) {
            Object.assign(viewModel, { type: 0 });
            this.$refs.modelViewsShare.Open(
                {
                    fileName: this.fileName,
                    urn: this.currentUrn,
                    objectStatus: this.objectStatus,
                },
                viewModel,
            );
        },
    },
};
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
@import '~common/stylus/mixin'
#modelViews >>>
  .el-dialog__body
    padding 7px 20px
#modelViews
  .cancel-btn
    width 100px
    height 40px
    margin-left 10px
    border-radius 20px
    border 0px
    outline none
    background-color #0C78E2
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/modelViews.vue